var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingbagIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6654 14.5833C25.982 14.5833 25.4154 14.0166 25.4154 13.3333V7.49992C25.4154 5.69992 24.2987 4.58325 22.4987 4.58325H17.4987C15.6987 4.58325 14.582 5.69992 14.582 7.49992V13.3333C14.582 14.0166 14.0154 14.5833 13.332 14.5833C12.6487 14.5833 12.082 14.0166 12.082 13.3333V7.49992C12.082 4.31659 14.3154 2.08325 17.4987 2.08325H22.4987C25.682 2.08325 27.9154 4.31659 27.9154 7.49992V13.3333C27.9154 14.0166 27.3487 14.5833 26.6654 14.5833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 29.6333C13.0012 29.6333 12.6833 29.5016 12.4489 29.2671C12.2144 29.0327 12.0827 28.7148 12.0827 28.3833C12.0827 28.0517 12.2144 27.7338 12.4489 27.4994C12.6833 27.2649 13.0012 27.1333 13.3327 27.1333H32.9327C33.4327 27.1333 33.8161 26.6999 33.7661 26.1999L32.6327 16.7166C32.2327 13.4833 31.6661 10.8333 25.9994 10.8333H13.9994C8.33275 10.8333 7.76608 13.4833 7.38275 16.7166L5.88275 29.2166C5.39941 33.3166 6.66608 36.6666 12.5161 36.6666H27.4827C32.7494 36.6666 34.2994 33.9499 34.2161 30.4166C34.2074 30.2029 34.1152 30.0012 33.9594 29.8547C33.8036 29.7082 33.5966 29.6287 33.3827 29.6333H13.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbagIc);
export default __webpack_public_path__ + "static/media/shoppingbag_ic.0d87c08913bea471c7f0e5ff46a599f1.svg";
export { ForwardRef as ReactComponent };